module.exports = __webpack_public_path__ + "static/media/calendar-caret-down.b56bcd33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-caret-down.svg
// module id = 839
// module chunks = 7